import ThisModule from "./PageWithData";

export default ThisModule;
